module.exports = __webpack_public_path__ + "img/down.b2eb96a6.png";